import { useEffect, useState } from 'react'
import { ArrowUp } from 'lucide-react'
import { useI18n } from '../i18n/useI18n'

interface Props {
  threshold?: number
  target?: HTMLElement | Window
}

export default function ScrollToTopButton({ threshold = 300, target }: Props) {
  const { t } = useI18n()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const scrollTarget = target ?? window
    const getScrollY = () =>
      scrollTarget instanceof Window ? scrollTarget.scrollY : scrollTarget.scrollTop

    const handleScroll = () => setVisible(getScrollY() > threshold)

    handleScroll()
    scrollTarget.addEventListener('scroll', handleScroll, { passive: true })
    return () => scrollTarget.removeEventListener('scroll', handleScroll)
  }, [threshold, target])

  const handleClick = () => {
    const scrollTarget = target ?? window
    if (scrollTarget instanceof Window) {
      scrollTarget.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      scrollTarget.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-[100px] left-1/2 -translate-x-1/2 w-full max-w-[430px] pointer-events-none z-40">
      <button
        type="button"
        onClick={handleClick}
        aria-label={t('stores.scrollToTop')}
        className="absolute right-4 w-12 h-12 rounded-full bg-navy text-white shadow-lg flex items-center justify-center tap-effect animate-fade-in pointer-events-auto"
      >
        <ArrowUp size={22} />
      </button>
    </div>
  )
}
